import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { omit } from "../utils";
import { Component } from "./TabContent.style";
import { ThemeProvider } from "styled-components";
import { theme } from "./../../theme";

const propTypes = {
  activeItem: PropTypes.any,
  className: PropTypes.string,
};

class TabContent extends React.Component {
  state = {
    activeItem: this.context.activeItem,
  };

  getChildContext() {
    const { activeItem } = this.state;
    return {
      activeItemId: activeItem,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.activeItem !== nextProps.activeItem
      ? { activeItem: nextProps.activeItem }
      : null;
  }

  render() {
    const { className } = this.props;

    const attributes = omit(this.props, Object.keys(propTypes));

    const classes = classNames("tab-content", className);
    return (
      <ThemeProvider theme={theme}>
        <Component>
          <div data-test="tabContent" {...attributes} className={classes} />
        </Component>
      </ThemeProvider>
    );
  }
}

TabContent.childContextTypes = {
  activeItemId: PropTypes.any,
  activeItem: PropTypes.string,
};
TabContent.contextTypes = {
  activeItem: PropTypes.string,
};

TabContent.propTypes = {
  activeItem: PropTypes.any,
  className: PropTypes.string,
};

export default TabContent;
export { TabContent as CDBTabContent };
